import React, { useState, useEffect } from 'react';
import { Table, Divider, Typography } from 'antd';
import type {ColumnsType} from 'antd/es/table';

import client from "../../utils/http-request";
import {formatRate} from "../../utils/roeUtils";

interface DataType {
  id: string
  country: string
  currency: string
  ccyToUsd: string
  usdToCcy: string
}


const defaultColumns: ColumnsType<DataType> = [
  {
    title: 'Currency',
    dataIndex: 'fromCurrency',
    fixed: 'left',
    width: 75
  },
  {
    title: 'Current Currency to USD',
    dataIndex: 'ccyToUsdRate',
    width: 130,
    render: formatRate
  },
  {
    title: 'USD to Current Currency',
    dataIndex: 'usdToCcyRate',
    width: 125,
    render: formatRate
  }
];


const SearchResult: React.FC<any> = ({searchCriteria}) => {
  const [columns, setColumn]= useState<ColumnsType<DataType>>([...defaultColumns]);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const resultColumn: ColumnsType<DataType> = [...defaultColumns];

    const buildSearchResult= async () => {
    if(!searchCriteria) {
      return;
    }

    const params = {
      effectiveDate: searchCriteria.date.format('YYYYMMDD'),
    }
    setLoading(true);
    const resRetrun: any = await client.request({
      method: 'get',
      withCredentials: true,
       url: '/gateway/gpd_roe_profile_route/roe/daily',
      params
    });
    const res:any[] = resRetrun.data;
    const displayRes = res.filter(roe=>roe.fromCurrency===roe.toCurrency);
  
    buildExtendColumn(res,displayRes);
    setColumn([...resultColumn]);
    setData([...displayRes]);
    setLoading(false);
  };

  const buildExtendColumn = (res:any[],displayRes:any[]) =>{
    res.forEach(roe => {
      if (resultColumn.filter((column: any) => column.dataIndex === roe.fromCurrency).length === 0) {
        resultColumn.push(
          {
            title: roe.fromCurrency,
            dataIndex: roe.fromCurrency,
            width: 100,
            render: formatRate
          });
      }
      const matchRecords = displayRes.filter(displyRoe => displyRoe.fromCurrency === roe.fromCurrency);
      if (matchRecords.length > 0) {
        matchRecords[0][roe.toCurrency] = roe.rate;
      }
    });
  }

  const handleTableChange = () => {
    buildSearchResult();
  };

  useEffect(() => {
    buildSearchResult();
  }, [searchCriteria]);

    return (
      <>
        <div style={{ background: 'white', padding: '0 16px 16px 16px', marginTop: '0px', tableLayout:'fixed', wordWrap:'inherit'}}>
          <Typography.Text strong style={{ fontSize: '14px' }}>Result</Typography.Text>
          <Divider style={{ borderBlockStartColor: 'rgba(0, 0, 0, 0.7)', margin: '16px 0' }} />
          <Table
            rowKey={(record) => record.id}
            dataSource={data}
            columns={columns}
            loading={loading}
            onChange={handleTableChange}
            bordered
            showHeader={true}
            scroll={{ y: 450 , x: '100%'}}
            size={"middle"}
          />
        </div>
      </>
    )
  }
  
  export default SearchResult
